import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { AppActionDispatcher } from './actions/app-action-dispatcher';
import { NgrxStoreLibService } from './ngrx-store-lib.service';


@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot({}),
    StoreRouterConnectingModule
    ],
  declarations: [],
  exports: [StoreModule],
  providers: [AppActionDispatcher, NgrxStoreLibService]
})
export class NgrxStoreLibModule {}

